import { createSelector } from 'reselect';
import { configSelector } from 'selectors/common';

import { defaultVisibilitySettings } from '../../const';
import { IRootState } from '../../reducers';
import { IViewVisibilitySetting } from '../../types';
import { adminSettingsSelector } from './adminSettings';
import { filterVisibilitySectionsByConfig, getMappedViewSettings } from './utils';

const localVisibilitySettingsSelector = createSelector(
  [(state: IRootState) => state.localVisibilitySettings, adminSettingsSelector, configSelector],
  (localVisibilitySettings, adminSettings, config): IViewVisibilitySetting[] => {
    if (adminSettings.loading || !localVisibilitySettings.sections || !adminSettings.content?.sections) {
      return [];
    }

    const filteredLocalSettings = filterVisibilitySectionsByConfig(localVisibilitySettings.sections, config);
    const defaultSettings = filterVisibilitySectionsByConfig(defaultVisibilitySettings, config);
    const settings = getMappedViewSettings(defaultSettings, filteredLocalSettings, adminSettings.content.sections);
    return settings;
  },
);

export default localVisibilitySettingsSelector;
